import { render } from "./assist.vue?vue&type=template&id=08a5754d&scoped=true"
import script from "./assist.vue?vue&type=script&lang=js"
export * from "./assist.vue?vue&type=script&lang=js"

import "./assist.vue?vue&type=style&index=0&id=08a5754d&lang=scss&scoped=true"

import exportComponent from "/Users/cengheji/Desktop/Arky/pro/chat28/admin/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a5754d"]])

export default __exports__